import provinceReducer from './provinceSlice';
import * as provinceActions from './actions';
import * as provinceSelector from './selector';

export {
  provinceActions,
  provinceSelector
}

export default provinceReducer